import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LocalDate } from '../../../store/models';
import { NOT_AVAILABLE } from '../../../common/constants';

@Component({
  selector: 'ui-info-field-item',
  templateUrl: './info-field-item.component.html',
  styleUrls: ['./info-field-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InfoFieldItemComponent {
  @Input() label: string;
  @Input() flat = false;
  @Input() text?: string | number;
  @Input() localDate?: LocalDate;
  @Input() cropTextNeeded?: boolean = false;
  @Input() testId: string;
  @Input() displayedBottomMessage?: boolean = false;

  notAvailable = NOT_AVAILABLE;
}
